import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import ContactUsDraver from './contact-us-draver.vue';

const MOUNT_ID = 'contact-us-draver-vue';

let contactUsApp: App<Element> | null = null;
let contactUsInstance: { open: () => void } | null = null;
let currentMountEl: HTMLElement | null = null;
let contactUsTriggersInitialized = false;

function resolveMountRoot(root?: ParentNode): HTMLElement | null {
  const fromDom = root
    ? (root.querySelector<HTMLElement>(`#${MOUNT_ID}`) ?? document.getElementById(MOUNT_ID))
    : document.getElementById(MOUNT_ID);

  if (fromDom) {
    return fromDom;
  }

  const dynamicMountEl = document.createElement('div');
  dynamicMountEl.id = MOUNT_ID;

  document.body.appendChild(dynamicMountEl);

  return dynamicMountEl;
}

function mountContactUsDrawer(root?: ParentNode): void {
  const mountEl = resolveMountRoot(root);

  if (!mountEl) {
    return;
  }

  if (contactUsApp && currentMountEl) {
    contactUsApp.unmount();
    currentMountEl.innerHTML = '';
  }

  const app = createApp(ContactUsDraver);

  app.use(AntDesignVue);

  const instance = app.mount(mountEl) as unknown as {
    open: () => void;
  };

  contactUsApp = app;
  contactUsInstance = instance;
  currentMountEl = mountEl;
}

export function openContactUsDrawer(): void {
  if (!contactUsApp || !contactUsInstance) {
    mountContactUsDrawer();
  }

  contactUsInstance?.open();
}

export function initContactUsDrawer(root?: ParentNode): void {
  mountContactUsDrawer(root);
}

export function initContactUsDrawerTriggers(): void {
  if (contactUsTriggersInitialized) {
    return;
  }

  contactUsTriggersInitialized = true;

  initContactUsDrawer();

  document.addEventListener('click', (event: Event) => {
    const target = event.target as HTMLElement | null;

    const trigger = target?.closest<HTMLElement>('[data-contact-us-open-modal]');

    if (!trigger) {
      return;
    }

    event.preventDefault();

    openContactUsDrawer();
  });
}
